import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import { Axios } from "../config";
import { useAuth } from "./Auth";
import "../Style/Login.css";
import { useNavigate } from "react-router-dom";
import logo from "../Images/Logo.png"; // Import your logo image
import BG1 from "../Images/BG3.jpeg";
import BG4 from "../Images/BG4.jpeg";

function LoginPage() {
  var navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [pw, setPW] = useState("");
  let isAuth = false;
  const auth = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("handling login");

    try {
      const response = await Axios.post("/HandleLogin", {
        username: username,
        pw: pw,
      });

      if (!response.data.success) {
        alert("Wrong Password");
      } else {
        auth.login(username, pw);
        var adminLoginPath = "/Admin";
        navigate(adminLoginPath);
      }
    } catch (error) {
      console.error("Error logging in:", error);
      alert("Error logging in. Please try again.");
    }
  };

  return (
    <div>
      <React.Fragment>
        <Navbar />
      </React.Fragment>
      <div className="">
        <div className="LoginScreen">
          <form action="" onSubmit={handleLogin}>
            <div className="logo-header">
              <div className="modalNames">
                <b>Admin Login</b>
              </div>
              <img src={logo} alt="Logo" className="logo-modal" />
            </div>
            <div>
              <label htmlFor="text">Username</label>
              <input
                type="text"
                placeholder="Enter email"
                onChange={(e) => setUsername(e.target.value)}
              />
              <label htmlFor="password">Password</label>
              <input
                type="password"
                placeholder="Enter password"
                onChange={(e) => setPW(e.target.value)}
              />
              <button type="submit">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default LoginPage;
